import SplitEDDChooseShippingMethod from 'components/SharedComponents/SplitEDD/SplitEDDChooseShippingMethod/SplitEDDChooseShippingMethod';

export default SplitEDDChooseShippingMethod;
